/**
 * Shows a global PrimeVue toast from anywhere (including plain JS modules that
 * can't call useToast()). Dispatches the window event `app-show-toast` with
 * detail `{ message: string, severity: string }`; App.vue listens and renders it.
 *
 * @param {*} message - Toast text (coerced to string)
 * @param {string} [severity='info'] - PrimeVue toast severity (info, success, warn, error, ...)
 */
export function showToast(message, severity = 'info') {
  try {
    if (typeof window !== 'undefined' && window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('app-show-toast', { detail: { message: String(message), severity } }));
    }
  } catch (e) {
    // fallback
    Console.log('Toast:', message);
  }
}

export default { showToast };
